import './EqClassCodeList.scss';

const EqClassCodeList = (props: any) => {

    const { eqClassCodeExample } = props;

    return (
        <table className="EqClassCodeListTable">
            {eqClassCodeExample?.length ? eqClassCodeExample?.map((item: any) => {
                return (
                <>
                    <tr>
                        <th></th>
                        <th className='pickup-truck'>{item?.categoryDescription}</th>
                        <th className='example'>Examples</th>
                    </tr>
                    {
                        item?.eqCategoryExamples?.length ?
                            item?.eqCategoryExamples?.map((code: any) => {
                                return (
                                    <tr>
                                        <td>{code.eqClassCode}</td>
                                        <td>{code.eqClassDesc}</td>
                                        <td>{code.example}</td>
                                    </tr>
                                )
                            })
                            : null
                    }
                </>
                )
            }) : null}
        </table>
    )
}

export default EqClassCodeList;